const constants = {
    jwtKey: 'seattle-jwt',
    roleKey: 'role',
    permissionsKey: 'permissions',
};

export default constants;
